<script setup>
import Load from '@/components/common/Load.vue'
import Side from '@/components/common/Sidebanner.vue'
import MediaBox  from '@/components/common/MediaBox.vue'
import axios  from "axios";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<div>
<v-card
    flat
    outlined
>
    <v-card-title class="py-1">
        <h2 class="ranking_head">プロジェクト分析</h2>
    </v-card-title>
    <v-card-text class="px-2 pt-3">
    <v-expansion-panels :disabled="menu_load_flg" flat outlined v-model="panel">
      <v-expansion-panel
          v-for="item in project_list"
          :key="item.search_label"
        class="my-0"
      >
        <v-expansion-panel-header style="font-size:1.3rem;min-height:50px!important" class="py-1">
            <span class="proname">{{ item.search_label }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-card flat tile v-if="menu_load_flg == false">
                <v-card-text class="py-0 px-0">
                    <v-list class="py-0">
                        <v-list-item v-for="item,index in selected_cat" :key="index" class="px-0" outlined>
                            <v-checkbox
                                dense
                                  v-model="selected"
                                 :label="item.text"
                                :color="item.checkedcolor"
                                :value="item.text"
                                hide-details
                            ></v-checkbox>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
            <Load v-else height="150px" />
        </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
    </v-card-text>
    <v-card-actions style="height:60px">
        <v-spacer />
        <v-radio-group
          v-model="inc_flg"
          row
        >
          <v-radio
            label="含む"
            value="1"
          ></v-radio>
          <v-radio
            label="含まない"
            value="2"
          ></v-radio>
        </v-radio-group>
        <v-spacer />
    </v-card-actions>
</v-card>
<MediaBox />

<Side />
</div>
</template>
<script>
  export default {
    data () {
      return {
        menu_load_flg : false,
        panel : [],
        selected_cat : [],
        selected     : [],
        project_list : [],
        timeout : null,
        tab : "",
        inc_flg : "1",
      }
    },
    watch : {
        selected : function(){
            if(this.menu_load_flg == true)
                return;
            clearTimeout(this.timeout);
            if(this.panel == null)
            {
                return;
            }
            this.timeout = setTimeout(() => {
                this.$emit("search",{group_id:this.project_list[this.panel].id,cats:this.selected,inc:this.inc_flg});
            }, 1000);

        },
        panel : function(){
            this.selected = [];
            this.selected_cat = [];
            if(this.panel == undefined)
            {
                this.$emit("search",null);
                return;
            }
            this.menu_load_flg = true;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                if(this.panel == undefined)
                    return;
                this.category_get(this.project_list[this.panel].id);
            }, 1000);
        },
        inc_flg : function(){
            if(this.menu_load_flg == true)
                return;
            clearTimeout(this.timeout);
            if(this.panel == null || this.selected.length==0)
            {
                return;
            }
            this.timeout = setTimeout(() => {
                this.$emit("search",{group_id:this.project_list[this.panel].id,cats:this.selected,inc:this.inc_flg});
            }, 1000);
        },
    },
    computed : {
        doc_id : function(){
            return this.$store.getters['doc_info/get_doc_id'];
        },
        doc_status : {
            get(){
                return this.$store.getters['doc_info/get_docstatus'];
            },
            set(val){
                let set_val = "";
                if(val != null)
                    set_val = val;
                console.log(set_val);
                this.$store.commit("doc_info/set_docstatus",set_val);
                if(this.doc_id != "")
                    this.setStatus();
            }
        },
    },
    methods : {
        setStatus : async function(){
            var params = new URLSearchParams();
            params.append("status",this.doc_status);
            params.append("doc_id",this.doc_id);
            axios.post("https://qlipper.jp/api/release/set_status",params)
			.catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            })
			;
        },
        get_project : async function(){
            axios.get("/api/project/get_sg_menu.php")
            .then(response => {
                this.project_list = response.data;
            })
			.catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        category_get : async function(id){
            let params = new URLSearchParams();
            this.$emit("search",{group_id:id});
            params.append('group_id', id);
            await axios.post("/api/result/get_iconresult",params)
            .then(response => {
                this.selected_cat = response.data;
                this.menu_load_flg = false;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },
    created : function(){
        this.get_project();
    },
  }
</script>

